import { Entity } from '@core/entities/entity'
import { IAuditDraftResult } from './IAuditDraftResult'

export class AuditDraftResult extends Entity<IAuditDraftResult> {
  id: number
  draftName: string
  templateName: string
}
